<template>
	<div class="user-container">
		<el-button type="success" style="margin-bottom: 20px;" @click="openDialog('1')">新增</el-button>
		<el-table :data="tableData" style="width: 100%" stripe border>
			<el-table-column prop="id" label="id">
			</el-table-column>
			<el-table-column prop="name" label="用户名">
			</el-table-column>
			<el-table-column prop="password" label="密码">
			</el-table-column>
			<el-table-column width="175">
				<template slot-scope="scope">
					<el-button type="primary" size="small" @click="openDialog('2',scope.row)">修改</el-button>
					<delPop @confirm="delUser(scope.row.name)"></delPop>
				</template>
			</el-table-column>
		</el-table>
		<div style="display: flex;justify-content: center;">
			<el-pagination background layout="prev, pager, next" :total="total" style="margin-top: 40px;" @current-change="changePage">
			</el-pagination>
		</div>
		<el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="35%">
			<div>
				<el-form label-width="80px" :model="userModel" ref="userForm" :rules="rules">
					<el-form-item label="用户名" prop="name">
						<el-input :disabled="dialogTitle == '修改'" v-model="userModel.name"></el-input>
					</el-form-item>
					<el-form-item label="密码" prop="password">
						<el-input :disabled="dialogTitle == '修改'" v-model="userModel.password"></el-input>
					</el-form-item>
					<el-form-item label="新密码" prop="newPassword" v-if="dialogTitle == '修改'">
						<el-input v-model="userModel.newPassword"></el-input>
					</el-form-item>
				</el-form>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="commit">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import mixins from '../../mixins.js'
	import {
		users,
		register,
		updateUser,
		delUser
	} from '../../api/user.js'
	export default {
		mixins: [mixins],
		data() {
			return {
				tableData: [],
				dialogTitle: '新增',
				dialogVisible: false,
				userModel: {},
				rules: {
					name: [{
						required: true,
						message: '请输入账号',
						trigger: 'blur'
					}],
					password: [{
						required: true,
						message: '请输入密码',
						trigger: 'blur'
					}]
				}
			}
		},
		methods: {
			async getData() {
				let res = (await users(this.queryParams)).data
				this.tableData = res.data
				this.total = res.count
			},
			openDialog(i, row) {
				if (i == 1) {
					this.dialogTitle = '新增'
					this.userModel = {}
				} else {
					this.dialogTitle = '修改'
					this.userModel = row
				}
				this.dialogVisible = true
			},
			async commit() {
				this.$refs.userForm.validate(async valid => {
					if (valid) {
						if (this.dialogTitle == '新增') {
							await register(this.userModel)
						}else{
							await updateUser(this.userModel)
						}
						this.getData()
						this.$message.success(this.dialogTitle + '成功')
						this.dialogVisible = false
					} else {
						return false
					}
				})
			},
			async delUser(name){
				await delUser(name)
				this.$message.success('删除成功')
				this.getData()
			}
		}
	}
</script>

<style>
</style>
